import { Component } from '@angular/core';
import { AppSettingsService } from 'src/app/services/app-settings.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent {
  bookkeepingStartDate = this.appSettingsService.getBookkeepingStartDate();

  constructor(private appSettingsService: AppSettingsService) {}

  saveBookkeepingStartDate() {
    this.appSettingsService.setBookkeepingStartDate(this.bookkeepingStartDate);
  }
}
